export default __webpack_public_path__ + "static/media/radio-btn-unselected.3cf032a5.svg";